// extracted by mini-css-extract-plugin
export var loadingSpinner = "_v-0";
export var spinnerContainer = "_v-1";